import { Box, Container, Group, Text } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { ManifestusLogo } from './ManifestusLogo';

function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      py="md"
      mt={40}
      style={{ borderTop: '1px solid rgba(0,0,0,.06)' }}
    >
      <Container size={960} px="md">
        <Group justify="space-between" align="center" wrap="nowrap" gap="xs">
          <Group gap="sm" align="center" wrap="nowrap">
            <Box style={{ marginTop: 0 }}>
              <ManifestusLogo h={20} variant="dimmed" />
            </Box>
            <Text size="xs" c="dimmed" style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
              Manifest yourself.
            </Text>
          </Group>
          <Text size="xs" c="dimmed" style={{ opacity: 0.3 }}>&copy; {year} Manifestus</Text>
        </Group>
      </Container>
    </Box>
  );
}

export function AppLayout() {
  return (
    <Box style={{ minHeight: '100vh', background: '#fafafa', color: '#1a1a1a', display: 'flex', flexDirection: 'column' }}>
      <Box style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, overflow: 'hidden' }}>
        <Box
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: 'radial-gradient(circle, rgba(0,0,0,.06) 1px, transparent 1px)',
            backgroundSize: '24px 24px',
            maskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, black 20%, transparent 70%)',
            WebkitMaskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, black 20%, transparent 70%)',
          }}
        />
        <Box style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: '#7c3aed', filter: 'blur(180px)', opacity: 0.04, top: -300, right: -200 }} />
        <Box style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: '#0ea5e9', filter: 'blur(180px)', opacity: 0.03, bottom: -300, left: -200 }} />
      </Box>

      <Box style={{ position: 'relative', zIndex: 1, flex: 1, display: 'flex', flexDirection: 'column' }}>
        <AppHeader />
        <Box style={{ flex: 1 }}>
          <Outlet />
        </Box>
        <AppFooter />
      </Box>
    </Box>
  );
}
